// Disallowed URL schemes that would execute script in the current origin or
// otherwise bypass the same-origin guarantees callers expect from a redirect.
const UnsafeScheme = /^\s*(javascript|data|vbscript):/i

// @ts-expect-error
window.setLocationHref = (path) => {
  if (typeof path !== 'string' || UnsafeScheme.test(path)) {
    return
  }
  window.location.href = path
}
